module.exports = __webpack_public_path__ + "castle-5b2d4fafd48b1b3d7b3c63d215d9d029.png";